import { render, staticRenderFns } from "./ComponentAvatar.vue?vue&type=template&id=997fcae2&"
import script from "./ComponentAvatar.vue?vue&type=script&lang=js&"
export * from "./ComponentAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports